// `YYYY-MM-DD` as a wall clock, never an instant: its arithmetic is UTC midnight, so no step drifts across a DST change.
export type DayKey = string

export const DAY_MS = 86_400_000

export const pad2 = (value: number) => String(value).padStart(2, '0')

export const utcMidnight = (key: DayKey) => Date.parse(`${key}T00:00:00Z`)

export const dayKeyOf = (instant: number) => new Date(instant).toISOString().slice(0, 10)

export const addDays = (key: DayKey, days: number) => dayKeyOf(utcMidnight(key) + days * DAY_MS)

// Monday-first everywhere, so the FR-H1 week grid and the date picker agree whatever the interface locale is.
export const weekStartKey = (key: DayKey) => addDays(key, -((new Date(utcMidnight(key)).getUTCDay() + 6) % 7))
